
















import ContentTop from '@/components/accumulation/ContentTop.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {Vue, Component} from 'vue-property-decorator';
import {State} from 'vuex-class';
import {Mall, GetAccumulationConfigurationsRequest} from 'supporter';
import PageTitle from '@/components/common/PageTitle.vue';
import {i18nInObjectList} from '@/utils/i18n';
import TuiGrid from 'tui-grid';

@Component({
  components: {
    top: ContentTop,
    PageTitle,
    ItemTable
  }
})
export default class AccumulationConfiguration extends Vue {
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private contentList: any[] = [];

  private created(): void {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
  private mounted(): void {
    const noData = this.$t('ACCUMULATION_CONFIGURATION_NO_DATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
  }
  private contentBottomOption: any = {
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    showTopcontent: false,
    excelDownInfo: {
      columns: {},
      fileName: '',
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {}
    }
  };

  private search(): void {
    let request: GetAccumulationConfigurationsRequest = {
      params: {
        mallNo: null,
        used: true,
        timestamp: new Date().getTime()
      }
    };
    this.$api.getAccumulationsConfigurations(request).then((res: any) => {
      this.contentList = [];
      this.contentList = res.data;
    });
  }

  private appendComma(parts: any): any {
    let commaVal = '';
    if (parts.length == 1) {
      commaVal = `${parts[0].replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')}`;
    } else if (parts.length == 2) {
      commaVal = `${parts[0].replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')}.${parts[1]}`;
    } else {
      commaVal = '';
    }
    return commaVal;
  }

  private gridProps = {
    options: {
      header: {
        height: 33
      },
      columnOptions: {
        resizable: true,
        minWidth: 50
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    columns: [
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_IS_EDITABLE',
        name: 'isEditable',
        align: 'center',
        minWidth: 60,
        formatter(data: any): any {
          if (!data.row.temporary) {
            return '';
          } else {
            const mall = data.row.mallNo;
            return `<a href="/accumulationConfiguration/modify/${mall}">${window.$t('ACCUMULATION_CONFIGURATION_EDIT')}</a>`;
          }
        },
        copyOptions: {
          useFormattedValue: true,
          customValue: function (value: any): any {
            return value;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_MALL_NAME',
        name: 'mallName',
        align: 'center',
        minWidth: 100,
        formatter: (data: any): any => {
          const mall = data.row.mallNo;
          const name = data.value;
          return `<a href="/accumulationConfiguration/modify/${mall}">${name}</a>`;
        },
        copyOptions: {
          useFormattedValue: true,
          customValue: function (value: any): any {
            return value;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_ACCUMULATION_RATE',
        name: 'accumulationRate',
        align: 'center',
        minWidth: 60,
        formatter(data: any) {
          if (!data.row.temporary) {
            return `${data.row.basic.accumulationRate} %`;
          } else {
            return '-';
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_ACCUMULATION_NAME',
        name: 'accumulationName',
        minWidth: 60,
        align: 'center',
        formatter(data: any) {
          if (data.row.temporary) {
            return '-';
          } else {
            return `${data.row.basic.accumulationName}`;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_SING_UP_ACCUMULATION',
        name: 'signUpAccumulation',
        minWidth: 100,
        align: 'center',
        formatter: (data: any): any => {
          let value = '-';
          if (data.row.temporary) {
            value = '-';
          } else if (!data.row.payment.signUpAccumulationUsable) {
            value = `${window.$t('ACCUMULATION_CONFIGURATION_GRIDS_SINGUP_ACCUMULATION_DISABLE')}`;
          } else {
            value = data.row.payment.signUpAccumulation.toLocaleString() + data.row.basic.accumulationUnit;
          }
          return value;
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_REVIEW_ACCUMULATION',
        name: 'reviewsAccumulation',
        minWidth: 140,
        align: 'center',
        formatter: (data: any): any => {
          if (data.row.temporary) {
            return '-';
          } else if (!data.row.payment.reviewAccumulationUsable) {
            return `${window.$t('ACCUMULATION_CONFIGURATION_GRIDS_SINGUP_ACCUMULATION_DISABLE')}`;
          } else {
            let value: any = '';
            value =
              data.row.payment.reviewAccumulation.reviewsLength.toLocaleString() +
              `${window.$t('ACCUMULATION_CONFIGURATION_WORDS_TEXT')}` +
              data.row.payment.reviewAccumulation.reviewsAccumulation.toLocaleString() +
              data.row.basic.accumulationUnit +
              `${window.$t('ACCUMULATION_CONFIGURATION_PAYMENT_UNIT')}`;
            return value;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_PHOTO_REVIEW_ACCUMULATION',
        name: 'photoReviewsAccumulation',
        minWidth: 140,
        align: 'center',
        formatter(data: any) {
          if (data.row.temporary) {
            return '-';
          } else if (!data.row.payment.reviewAccumulationUsable) {
            return `${window.$t('ACCUMULATION_CONFIGURATION_GRIDS_SINGUP_ACCUMULATION_DISABLE')}`;
          } else {
            let value: any = '';
            value =
              data.row.payment.reviewAccumulation.photoReviewsLength.toLocaleString() +
              `${window.$t('ACCUMULATION_CONFIGURATION_WORDS_TEXT')}` +
              data.row.payment.reviewAccumulation.photoReviewsAccumulation.toLocaleString() +
              data.row.basic.accumulationUnit +
              `${window.$t('ACCUMULATION_CONFIGURATION_PAYMENT_UNIT')}`;
            return value;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_BIRTHDAY_ACCUMULATION',
        name: 'birthdayAccumulation',
        minWidth: 100,
        align: 'center',
        formatter: (data: any): any => {
          if (data.row.temporary) {
            return '-';
          } else if (!data.row.payment.birthdayAccumulationUsable) {
            return `${window.$t('ACCUMULATION_CONFIGURATION_GRIDS_SINGUP_ACCUMULATION_DISABLE')}`;
          } else {
            let value: any = data.row.payment.birthdayAccumulation.toLocaleString() + data.row.basic.accumulationUnit;
            return value;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_APP_INSTALL_ACCUMULATION',
        name: 'appInstallAccumulation',
        minWidth: 100,
        align: 'center',
        formatter: (data: any): any => {
          if (data.row.temporary) {
            return '-';
          } else if (!data.row.payment.appInstallAccumulationUsable) {
            return `${window.$t('ACCUMULATION_CONFIGURATION_GRIDS_SINGUP_ACCUMULATION_DISABLE')}`;
          } else {
            let value: any = data.row.payment.appInstallAccumulation.toLocaleString() + data.row.basic.accumulationUnit;
            return value;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_ACCUMULATION_USE_MIN_PRODUCT_PRICE',
        name: 'accumulationUseMinProductPrice',
        minWidth: 140,
        align: 'center',
        formatter: (data: any): any => {
          if (data.row.temporary) {
            return '-';
          } else if (!data.row.use.productPriceMinimumLimitUsable) {
            return `${window.$t('ACCUMULATION_CONFIGURATION_NO_LIMIT')}`;
          } else {
            let value: any = data.row.use.productPriceMinimum.toLocaleString() + `${window.$t('ACCUMULATION_CONFIGURATION_OUT_LIMIT')}`;
            return value;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_ACCUMULATION_USE_MIN_PRICE',
        name: 'accumulationUseMinPrice',
        minWidth: 140,
        align: 'center',
        formatter: (data: any): any => {
          if (data.row.temporary) {
            return '-';
          } else if (!data.row.use.minimumUsePriceLimitUsable) {
            return `${window.$t('ACCUMULATION_CONFIGURATION_NO_LIMIT')}`;
          } else {
            let value: any = data.row.use.minimumUsePrice.toLocaleString() + data.row.basic.accumulationUnit + ` ${window.$t('ACCUMULATION_CONFIGURATION_PRICE_UNIT')}`;
            return value;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_ACCUMULATION_USE_MAX_RATE',
        name: 'accumulationUseMaxRate',
        minWidth: 140,
        align: 'center',
        formatter: (data: any): any => {
          if (data.row.temporary) {
            return '-';
          } else if (!data.row.use.maximumUseRateLimitUsable) {
            return `${window.$t('ACCUMULATION_CONFIGURATION_NO_LIMIT')}`;
          } else {
            let value: any = `${window.$t('ACCUMULATION_CONFIGURATION_TOTAL_PAYMENT')} ${data.row.use.maximumUseRate} %`;
            return value;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_ACCUMULATION_GIVE_POINT',
        name: 'accumulationGivePoint',
        minWidth: 140,
        align: 'center',
        formatter(data: any) {
          if (data.row.temporary) {
            return '-';
          } else {
            if (data.row.basic.accumulationReserveTime === 'IMMEDIATE') {
              return `${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POINT_TEXT')}` + ` ${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POIN_IMMEDIATE')}`;
            }
            if (data.row.basic.accumulationReserveTime === 'NEXTDAY') {
              return `${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POINT_TEXT')}` + ` ${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POIN_NEXTDAY')}`;
            }
            if (data.row.basic.accumulationReserveTime === 'DAY_AFTER_TOMMOROW') {
              return `${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POINT_TEXT')}` + ` ${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POIN_DAY_AFTER_TOMMOROW')}`;
            }
            if (data.row.basic.accumulationReserveTime === 'AFTER_A_WEEK') {
              return `${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POINT_TEXT')}` + ` ${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POIN_AFTER_A_WEEK')}`;
            }
            if (data.row.basic.accumulationReserveTime === 'AFTER_TWO_WEEK') {
              return `${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POINT_TEXT')}` + ` ${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POIN_AFTER_TWO_WEEK')}`;
            }
            if (data.row.basic.accumulationReserveTime === 'AFTER_TWENTY_DAYS') {
              return `${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POINT_TEXT')}` + ` ${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POIN_AFTER_TWENTY_DAYS')}`;
            }
            if (data.row.basic.accumulationReserveTime === 'AFTER_THIRTY_DAYS') {
              return `${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POINT_TEXT')}` + ` ${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POIN_AFTER_THIRTY_DAYS')}`;
            }
            if (data.row.basic.accumulationReserveTime === 'NEXT_MONTH') {
              return `${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POINT_TEXT')}` + ` ${window.$t('ACCUMULATION_CONFIGURATION_ACCUMULATION_POIN_NEXT_MONTH')}`;
            }
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_EXPIRE_ACCUMULATION_VALID_PERIOD',
        name: 'accumulationValidPeriod',
        minWidth: 200,
        align: 'center',
        formatter(data: any) {
          if (data.row.temporary) {
            return '-';
          } else {
            const period = data.row.basic.accumulationValidPeriod;
            const year = parseInt((period / 12) as any);
            const month = period % 12;
            let value = `${window.$t('ACCUMULATION_CONFIGURATION_PAY_TIME')} ${year}${window.$t('ACCUMULATION_CONFIGURATION_YEAR')} ${month}${window.$t(
              'ACCUMULATION_CONFIGURATION_MOUNTH'
            )} (${period}${window.$t('ACCUMULATION_CONFIGURATION_MOUNTH')})`;
            return value;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_EXPIRED_NOTIFICATION_POINT',
        name: 'expireNotificationBeforeDay',
        minWidth: 140,
        align: 'center',
        formatter(data: any) {
          if (data.row.temporary) {
            return '-';
          } else if (!data.row.basic.expireNotificationUsable) {
            return `${window.$t('ACCUMULATION_CONFIGURATION_GRIDS_SINGUP_ACCUMULATION_DISABLE')}`;
          } else {
            let theDay: any = data.row.basic.expireNotificationBeforeDay;
            let value: any = `${window.$t('ACCUMULATION_CONFIGURATION_EXPIRE_TEXT', {day: theDay})}`;
            return value;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_REGISTER_YMDT',
        name: 'createdDateTime',
        minWidth: 150,
        align: 'center',
        formatter(data: any) {
          if (data.row.updateAdminName === '-') {
            return '-';
          } else {
            return data.value;
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_UPDATE_ADMIN',
        name: 'updateAdminName',
        minWidth: 70,
        align: 'center',
        formatter(data: any) {
          if (data.value) {
            return data.value;
          } else {
            return '-';
          }
        }
      },
      {
        header: 'ACCUMULATION_CONFIGURATION_GRIDS_HEADER_UPDATE_YMDT',
        name: 'updatedDateTime',
        minWidth: 150,
        formatter(data: any) {
          if (data.row.updateAdminName === '-') {
            return '-';
          } else {
            return data.value;
          }
        }
      }
    ]
  };
}
